import { render } from "./index.vue?vue&type=template&id=583092ec&scoped=true"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=583092ec&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-583092ec"],['__file',"src/views/jbh/achievementManage/accountSafetyLevelSetting/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "583092ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('583092ec', __exports__)) {
    console.log('reload')
    api.reload('583092ec', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=583092ec&scoped=true", () => {
    console.log('re-render')
    api.rerender('583092ec', render)
  })

}


export default __exports__